module.exports = __webpack_public_path__ + "static/media/ulldeltemps_medium.831d1803.jpg";